import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DeliveryAddress } from '@components/templates/shoppingCart';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useGetAllGeoDistricts } from '@services/useGetAllGeoDistricts';
import { useGetMyAccountAddresses } from '@services/useGetMyAccountAddresses';
import { useGetCart } from '@services/useGetCart';

export function DeliveryAddressPage() {
    const { t, i18n } = useTranslation();
    const { request: requestCart } = useGetCart();
    const { request: requestGetAllGeoDistricts } = useGetAllGeoDistricts();
    const { request: requestGetMyAccountAddresses } = useGetMyAccountAddresses();

    const translations = {
        title: t('delivery-address-component.metatags.title'),
        description: t('delivery-address-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.orderDeliveryAddress,
        index: false,
    });

    useEffect(() => {
        requestGetMyAccountAddresses();
        requestGetAllGeoDistricts();
        // get updated data
        requestCart({});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);

    return <DeliveryAddress />;
}
